<template>
  <v-select
    :items="cupons"
    label="Cupons"
    item-text="text"
    item-value="value"
    v-model="cupomSelecionado"
  />
</template>

<script>
export default {
  name: 'FiltroCupons',
  data() {
    return {
      cupons: [
        {
          text: 'Todos',
          value: null
        },
        {
          text: 'Com cupom',
          value: true
        },
        {
          text: 'Sem cupom',
          value: false
        }
      ],
      cupomSelecionado: null
    }
  },
  watch: {
    cupomSelecionado() {
      this.$emit('filtrar-cupons', {
        com_cupom: this.cupomSelecionado
      })
    }
  }
}
</script>
